module.exports = __webpack_public_path__ + "img/logo_title.94f417b6.png";